module.exports = __webpack_public_path__ + "static/media/C3.4a7e8952.PNG";